(ns dashboard.views.browser-extension.questionnaire.subs
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::question-reorder-enabled
 (fn [db [_]]
   (get-in db [:question-drag-enabled] false)))

(rf/reg-sub
 ::has-question-restore-state
 (fn [db [_ question-id]]
   (contains? (get-in db [:browsers-extension :question-list :question-restore-state])
              question-id)))

;; Section reordering

(rf/reg-sub
 ::section-reorder-enabled
 (fn [db [_]]
   (get-in db [:section-reorder-enabled] false)))
